module.exports = __webpack_public_path__ + "static/media/icon-full-colour.79bf1cba.png";